export default __webpack_public_path__ + "static/media/10.2ddb3455.jpg";